
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Services = lazy(() => import('../pages/services/page'));
const Storage = lazy(() => import('../pages/storage/page'));
const Laboratory = lazy(() => import('../pages/laboratory/page'));
const TankLeasing = lazy(() => import('../pages/tank-leasing/page'));
const Maritime = lazy(() => import('../pages/maritime/page'));
const Railway = lazy(() => import('../pages/railway/page'));
const MotorTransport = lazy(() => import('../pages/motor-transport/page'));
const Terminals = lazy(() => import('../pages/terminals/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/storage',
    element: <Storage />,
  },
  {
    path: '/laboratory',
    element: <Laboratory />,
  },
  {
    path: '/tank-leasing',
    element: <TankLeasing />,
  },
  {
    path: '/maritime',
    element: <Maritime />,
  },
  {
    path: '/railway',
    element: <Railway />,
  },
  {
    path: '/motor-transport',
    element: <MotorTransport />,
  },
  {
    path: '/terminals',
    element: <Terminals />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
